/*--------------------------------------
            SLIDER INSTAGRAM
 --------------------------------------*/
SliderInstagram = {
  init: function () {
    var swiper = new Swiper(".swiper-instagram", {
      slidesPerView: "auto",
      autoplay: {
        delay: 4000,
      },
      allowTouchMove: false,
      loop: true,
      speed: 600,
      mousewheel: {
        invert: false,
        forceToAxis: true
      },
      freeMode: {
        enabled: false,
        sticky: true,
        momentumBounce: false

      }
    });
  }
};

$(function () {
  SliderInstagram.init();
});